module.exports = "../fonts/SFUIText-Bold.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SFUIText-Bold.otf
// module id = 573
// module chunks = 0